import Listagem from "./Listagem";
import {ModalDetalhePrescricaoProvider} from "../ModalDetalhePrescricaoContext";
import {ConfirmProvider} from "material-ui-confirm";

export default function ListarTodos() {
    return (
        <>
            <ConfirmProvider defaultOptions={{
                title: 'Excluir item',
                cancellationText: "Cancelar",
                confirmationText: "Excluir",
                confirmationButtonProps: {variant: 'contained', color: 'error'}
            }}>
                <ModalDetalhePrescricaoProvider>
                    <Listagem/>

                </ModalDetalhePrescricaoProvider>
            </ConfirmProvider>
        </>
    )
}

